import { useOperatorRole } from '@features/auth';
import { ROLE_LABEL } from '@lib/operator';

/**
 * Why half this screen's controls are greyed out.
 *
 * A disabled button with no explanation is the worst outcome of adding RBAC:
 * the operator cannot tell "you are not allowed" from "this app is broken", and
 * the second reading is the one people act on. One line at the top of the
 * screen turns every disabled control below it into an answer.
 *
 * Renders nothing for an operator who can write, so the notice only ever
 * appears where it explains something visible.
 */
export function ReadOnlyNotice() {
    const role = useOperatorRole();
    if (role !== 'read-only') return null;

    return (
        <div
            role="status"
            className="mb-4 rounded-lg border border-warning-line bg-warning-surface px-4 py-2.5 text-[12.5px] leading-relaxed text-warning-strong"
        >
            <strong className="font-semibold">{ROLE_LABEL['read-only']} access.</strong> You can see
            every flag and how it resolves, but not change one. Ask the platform team for the tier
            your work needs.
        </div>
    );
}
